import PropTypes from "prop-types"

import OnboardingTile from "./onboarding_tile"
import Header from "./header"

import "./index.scss"

const ServiceSelection = ({
  channels,
  onNext,
  toggleChannel,
  showFooter,
  channelSelected,
  newUserOnboarding,
  onClickBack,
}) => {
  let headerTitle = newUserOnboarding ? "Welcome to IFTTT!" : "Applet Discovery"

  return (
    <>
      <Header title={headerTitle} onClickBack={onClickBack} />
      <div styleName="container">
        <div>
          <p className="txt-body-3">
            To help you get personalized recommendations, pick at least one of
            the following that you use regularly.
          </p>
          <ul styleName="service-list">
            {channels.map(c => (
              <li key={c.module_name}>
                <OnboardingTile
                  onClick={() => toggleChannel(c.module_name)}
                  onboardingItem={c}
                  selected={channelSelected(c.module_name)}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {showFooter && (
        <footer styleName="onboarding-footer">
          <div styleName="wide-content">
            {newUserOnboarding && (
              <div>Great choices! Let&rsquo;s learn about Applets now.</div>
            )}
            <button
              onClick={onNext}
              className="button-tertiary button-on-color"
            >
              Continue
            </button>
          </div>
          <div styleName="narrow-content">
            <button
              onClick={onNext}
              className="button-tertiary button-on-color"
            >
              Continue
            </button>
          </div>
        </footer>
      )}
    </>
  )
}

ServiceSelection.propTypes = {
  channels: PropTypes.array.isRequired,
  channelSelected: PropTypes.func.isRequired,
  newUserOnboarding: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  showFooter: PropTypes.bool.isRequired,
  toggleChannel: PropTypes.func.isRequired,
  onClickBack: PropTypes.func,
}

export default ServiceSelection
